export const APP_ROUTES = {
    LOGIN: 'login',
    REGISTER: 'registration',
    PASSWORD_RESET: 'password-reset',
    DASHBOARD: 'dashboard',
    PLAN_FOUND: 'registration/plan-found',
    CREATE_ACCOUNT: 'registration/createAccount',
    CREATE_ACCOUNT_CONFIRMATION: 'registration/confirmation',
    WHY_CREATE_ACCOUNT: 'login/whyCreateAccount',
    MY_PLAN: 'my-plan',
    UNLINK_SUCCESS: 'my-plan/unlink-success',
    PAYMENTS: 'payments',
    CANCEL_PLAN: 'cancel-plan',
    PERKS_AND_BENEFITS: 'perks-and-benefits',
    ACCEPT_OFFER_CELEBRATION: 'cancel-plan/accept-offer-celebration',
    AMOUNT_DUE: 'cancel-plan/amount-due',
    CANCEL_CONFIRMATION: 'cancel-plan/cancel-confirmation',
    LINK_PLAN:'dashboard/linkNewPlan',
    FIND_PLAN:'dashboard/linkPlan',
    MAKE_PAYMENT: 'make-payment',
    MAKE_PAYMENT_VIVR: 'make-payment-vivr',
    UPDATE_BILLING_PAYMENTS:'payments/update-billing',
    PROFILE:'profile',
    EDIT_ADDRESS:'profile/editAddress/',
    EDIT_LOGIN_INFORMATION:'profile/edit-password/',
    EDIT_CONTACT_INFORMATION:'profile/edit-contact-information/',
    UPDATE_PROFILE_PAYMENTS:'profile/update-billing',
    CLAIM_HISTORY:'claim-history',
    CLAIM_DETAILS:'claim-history/claim-details',
    SESSION_TIMEOUT: 'session-timeout',
    CREATE_REQUEST: 'service-request/create-request',
    SERVICE_REQUEST:'service-request',
    SER_REQ_CATEGORY_AND_ITEMS: 'service-request/selected-category-and-items',
    SER_REQ_CLAIM_NOT_COVERED: 'service-request/request-error',
    SER_REQ_WHAT_IS_ISSUE_PAGE:'service-request/what-is-issue',
    ADD_ITEM: 'service-request/select-item',
    ADD_CATEGORY: 'service-request/select-category',
    SCHEDULE_APPOINTMENT: 'service-request/schedule-appointment',
    SCHEDULE_APPOINTMENT_SP_COMPETE: 'service-request/schedule-appointment-sp-compete',
    SCHEDULE_APPOINTMENT_SP_COMPETE_V2: 'service-request/schedule-appointment-sp-compete-v2',
    SER_REQ_REVIEW_REQ_PAGE:'service-request/review-request',
    MY_SERVICE_REQUEST: 'my-service-requests',
    CLAIM_CREDIT: 'service-request/claim-reimbursement',
    SERVICE_REQUEST_CONFIRMATION: 'service-request/request-confirmation',
    PM_SELECT_TRADE: 'service-request/pm/select-trade',
    PM_REIMBURSEMENT: 'service-request/pm/reimbursement-instructions',
    SER_REQ_TECHNICIAN_NOT_FOUND:'service-request/technician-not-found',
    SERVICE_DETAILS: 'my-service-requests/detail-requests/',
    OOPS_PAGE: 'oops_page',
    CONTACT_US: 'contact-us',
    UPDATE_BILLING_DASHBOARD:'dashboard/update-billing',
    UPDATE_BILLING_MYPLAN:'my-plan/update-billing',
    UPDATE_BILLING_SERVICE_REQUESTS:'my-service-requests/update-billing',
    SPECIAL_MEMBER_OFFER: 'special-member-offer',
    SPECIAL_MEMBER_OFFER_FORM: 'special-member-offer-form',
    SPECIAL_MEMBER_OFFER_V2: 'special-member-offer-v2',
    SPECIAL_MEMBER_OFFER_FORM_V2: 'special-member-offer-form-v2',
    SPECIAL_MEMBER_OFFER_V2_ENROLL_REVIEW: 'special-member-offer-v2/enroll-review',
    SPECIAL_MEMBER_OFFER_V2_ENROLL_SUCCESS: 'special-member-offer-v2/enroll-success'
};
